module.exports = ".table .produtoCol {\r\n  min-width: 200px;\r\n}\r\n.table .cpfCol {\r\n  min-width: 110px;\r\n}\r\n"